import React from 'react';


export function France(props) {
	return (
		<svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_301_496)">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M0 -21.3803H513V363.37H0V-21.3803Z" fill="white" />
				<path fill-rule="evenodd" clip-rule="evenodd" d="M0 -21.3803H170.973V363.37H0V-21.3803Z" fill="#00267F" />
				<path fill-rule="evenodd" clip-rule="evenodd" d="M342.027 -21.3803H513V363.37H342.027V-21.3803Z" fill="#F31830" />
			</g>
			<defs>
				<clipPath id="clip0_301_496">
					<rect width="513" height="341.999" fill="white" transform="translate(0 -0.00585938)" />
				</clipPath>
			</defs>
		</svg>

	);
}